<template>
  <div class="modal-content rounded-16 overflow-hidden">
    <div
      class="modal-header c-50"
      :class="'bgc-' + color"
    >
      <div
        :class="'c-' + color"
        class="c-200 text-sm modal-title w-100 flex-grow-1 text-sentence"
      >
        <span
          v-if="id"
          class="text-sentence"
        >
          {{ $t('message.edit_this_x_action', { type: type }) }}
        </span>
        <span
          v-else
          class="text-sentence"
        >
          {{ $t('message.add_a_x_action', { type: type }) }}
        </span>
      </div>
      <button
        type="button"
        class="d-block ms-auto btn-close"
        aria-label="Close"
        @click="closeModal"
      />
    </div>
    <div class="modal-body">
      <action-form
        :id="id"
        :type="type"
        :available-teams="teams"
        @submit-action-form="handleSubmit"
      />
    </div>
  </div>
</template>
<script>
import ActionForm from '@/views/components/ActionForm';
import { mapActions } from 'pinia';
import { useModalStore } from '../../../stores/modal';

export default {
  components: { ActionForm },
  emits: ['submitModal'],
  methods: {
    ...mapActions(useModalStore, ['closeModal']),
    handleSubmit(action) {
      this.$emit('submitModal', action);
      this.closeModal();
    },
  },
  computed: {
    typeName() {
      return this.$t('message.' + this.type);
    },
    color() {
      switch (this.type) {
        case 'personal':
          return 'paars';
        case 'team':
          return 'blauw';
        case 'company':
          return 'okergeel';
        default:
          return 'paars';
      }
    },
  },
  props: ['type', 'id', 'teams'],
};
</script>
